export default "__VITE_ASSET__CjWPdYTp__"